document.addEventListener('DOMContentLoaded', function () {
  var source = document.querySelector('#collection-seo-source');
  var target = document.querySelector('#collection-seo-accordion');

  if (!source || !target) return;

  var content = source.querySelector('.metafield-rich_text_field') || source;
  var children = Array.from(content.children);

  if (!children.length) return;

  var accordion = document.createElement('div');
  accordion.className = 'ocd-collection-seo-accordion';

  var current = null;
  var hasHeading = children.some(function (el) {
    return el.tagName.toLowerCase() === 'h2';
  });

  function createItem(title) {
    var item = document.createElement('details');
    item.className = 'ocd-collection-seo-accordion__item';

    var summary = document.createElement('summary');
    summary.innerHTML = '<span>' + title + '</span><span class="ocd-accordion-plus">+</span>';

    var body = document.createElement('div');
    body.className = 'ocd-collection-seo-accordion__content';

    item.appendChild(summary);
    item.appendChild(body);
    accordion.appendChild(item);

    return item;
  }

  if (!hasHeading) {
    current = createItem('About ' + document.title.split('|')[0].trim());

    children.forEach(function (el) {
      current.querySelector('.ocd-collection-seo-accordion__content').appendChild(el.cloneNode(true));
    });
  } else {
    children.forEach(function (el) {
      if (el.tagName.toLowerCase() === 'h2') {
        current = createItem(el.textContent.trim());
      } else if (current) {
        current.querySelector('.ocd-collection-seo-accordion__content').appendChild(el.cloneNode(true));
      }
    });
  }

  if (accordion.children.length) {
    target.appendChild(accordion);
  }
});